import type { CSSProperties } from 'react';
import { Wrapper, LeftSide, RightSide, ContentInner } from './SplitLayout.styles';
import type { SplitLayoutProps } from './SplitLayout.types';

export function SplitLayout({
  left,
  right,
  leftWidth = '58%',
  height = '90vh',
  contentMaxWidth = '480px',
  contentGap = '64px',
}: SplitLayoutProps) {
  const wrapperStyle = {
    '--split-height': height,
  } as CSSProperties;

  const leftStyle = {
    '--split-left-width': leftWidth,
  } as CSSProperties;

  const rightStyle = {
    '--split-right-width': `calc(100% - ${leftWidth})`,
  } as CSSProperties;

  const innerStyle = {
    maxWidth: contentMaxWidth,
    gap: contentGap,
  } as CSSProperties;

  return (
    <Wrapper style={wrapperStyle}>
      <LeftSide style={leftStyle}>{left}</LeftSide>
      <RightSide style={rightStyle}>
        <ContentInner style={innerStyle}>{right}</ContentInner>
      </RightSide>
    </Wrapper>
  );
}
